// Redirect.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { generatePath, useParams, Navigate, useLocation } from 'react-router';
import withRouter from '../component/WithRouter.jsx';
import { EMPTY_OBJECT, NULL_FUNCTION } from '../resource/defaults.js';

const isServer = typeof window === 'undefined';

export const Redirect = ({
  to = '',
  replace = true,
  state = null,
  status = 301,
  staticContext = EMPTY_OBJECT,
  pushState = NULL_FUNCTION,
  replaceState = NULL_FUNCTION,
}) => {
  const params = useParams();
  const { search } = useLocation();

  let redirectPath = '';
  if (typeof to === 'string') {
    redirectPath = generatePath(to, params) + search;
  } else {
    const { pathname = '', search = '' } = to;
    redirectPath = generatePath(pathname, params) + search;
  }

  // Server Side
  if (isServer && redirectPath) {
    const method = replace ? replaceState : pushState;
    staticContext.url = redirectPath;
    staticContext.status = status;
    method(redirectPath, state);
    return null;
  }

  // Client Side
  return <Navigate to={redirectPath} replace={replace} state={state} />;
};

Redirect.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  replace: PropTypes.bool,
  state: PropTypes.any,
  status: PropTypes.number,
  staticContext: PropTypes.object,
  pushState: PropTypes.func,
  replaceState: PropTypes.func,
};

export default withRouter(Redirect);
